import React from "react";
import { useEffect } from "react";
import parse from "html-react-parser";
import { useRef } from "react";
import itag from "../../../../assets/information-button.svg";
import { Tooltip } from "antd";
const WidgetNote = ({ note, isPdfPreview, customclass }) => {
  const noteRef = useRef(null);
  useEffect(() => {}, [noteRef, noteRef?.current?.clientHeight]);
  return (
    <div
      className={`widgetCard--note ${
        !isPdfPreview ? "widgetCard--minheight" : ""
      }`}
      ref={noteRef}
    >
      <div className="widgetCard--note--title">
        Analyst Notes
        {note ? (
          <Tooltip
            title={
              isPdfPreview
                ? "Please keep your note concise, as it will be displayed in a fixed-size box."
                : "Please keep your note concise, as it will be displayed in a fixed-size box in PDF report."
            }
          >
            <img
              src={itag}
              alt="information"
              className={`cursor-pointer ml-1`}
              // style={{ width: "18px", height: "18px" }}
            />
          </Tooltip>
        ) : (
          ""
        )}
      </div>
      <div
        className={`widgetCard--note--content ${
          customclass ? customclass : ""
        }`}
      >
        {parse(note)}
      </div>
    </div>
  );
};

export default WidgetNote;
